import { supabase } from '../../../shared/api/supabase/supabaseClient';

export const loginUser = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  if (error) throw error;
  return data;
};

export const requestPasswordReset = async (email) => {
  const { data, error } = await supabase.auth.resetPasswordForEmail(email);
  if (error) throw error;
  return data;
};

export const updateNewPassword = async (new_password) => {
  const { data, error } = await supabase.auth.updateUser({
    password: new_password,
  });
  if (error) throw error;
  return data;
};

export const registerUser = async (email, password, metadata = {}) => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: { data: metadata },
  });
  if (error) throw error;
  return data;
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};
